import React from 'react';
import { PushOptInBanner } from './PushToggleCard';
import { useAuth } from '../context/AuthContext';
import { useAgentAuth } from '../context/AgentAuthContext';

/**
 * Mounts PushOptInBanner with the currently logged-in user identity.
 * Guest sessions are skipped (no banner) — opt-in is only prompted
 * once a user has signed in so we can target segmented campaigns.
 */
const PushOptInMount = () => {
  const { user } = useAuth() || {};
  const { agent } = useAgentAuth() || {};

  if (user && user.id) {
    return <PushOptInBanner user_id={user.id} user_type="b2c" />;
  }
  if (agent && agent.id) {
    return <PushOptInBanner user_id={agent.id} user_type="agent" />;
  }
  return null;
};

export default PushOptInMount;
